import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

// Import helpers
import { languagesOptions } from 'helpers/languages';
import { getNewPath } from './helpers';

const { Option } = Select;

const LanguageDropdown = () => {
	const { pathname, search } = useLocation();
	const { i18n } = useTranslation();

	const handleSetLanguage = (newLng) => {
		const newPath = getNewPath({ pathname, newLng });
		window.location.replace(`${newPath}${search}`);
	};

	return (
		<Select
			value={i18n.language}
			style={{ width: 70 }}
			onChange={handleSetLanguage}
		>
			{languagesOptions.map(({ value, name }) => (
				<Option key={value} value={value}>
					{name}
				</Option>
			))}
		</Select>
	);
};

export default LanguageDropdown;
